/*
 * @Description:
 * @Author: wjx
 * @Date: 2019-03-29 16:53:07
 * @LastEditTime: 2022-07-22 18:08:35
 */

//http://saas-gongye-pc.jimijiayuan.cn
//http://saas-gongye-pc.yxvzb.com
//
const getDomain = () => {
  let hostname = window.location.hostname;
  let len = 0;
  if (process.env.NODE_ENV !== 'development') {
    hostname = hostname.split('.');
    len = hostname.length;
    hostname = `${hostname[len - 2]}.${hostname[len - 1]}`;
  }
  return hostname;
};

console.log(process.env.NODE_ENV, process.env.VUE_APP_SCENE, '---当前环境');
console.log(getDomain(), '---当前一级域名');
console.log(process.env.VUE_APP_WEBVIEW, '---当前webview域名');

const config = {
  token: 'gongyeSaaSToken',
  domain: getDomain(),
  iframeUrl: process.env.VUE_APP_WEBVIEW,
  webPath: '/html/index.html#',
  webViewUrl: process.env.VUE_APP_WEBVIEW,
  biUrl: process.env.VUE_APP_BI_DOMAIN,
  fileViewUrl: '//cdn.yxvzb.com/WEB/SaaS/file-view/index.html'
};
export default config;
